import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'label', 'badge']
  static values = {
    url: String,
    excluded: Boolean,
    excludedLabel: String,
    includedLabel: String,
    excludedTitle: String,
    includedTitle: String
  }

  async toggle(event) {
    event.preventDefault()
    if (this.buttonTarget.disabled) return
    this.buttonTarget.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: { 'Accept': 'application/json', 'X-CSRF-Token': this._csrfToken() }
      })
      if (!response.ok) throw new Error(`Toggle failed (${response.status})`)
      const data = await response.json()
      this._applyState(data.excluded_from_training)
    } catch (error) {
      console.error('Failed to toggle weight=0:', error)
      this.buttonTarget.classList.add('ring-2', 'ring-red-400')
      setTimeout(() => this.buttonTarget.classList.remove('ring-2', 'ring-red-400'), 1500)
    } finally {
      this.buttonTarget.disabled = false
    }
  }

  _applyState(excluded) {
    this.excludedValue = excluded
    this.element.dataset.excluded = excluded ? 'true' : 'false'

    this.labelTarget.textContent = excluded ? this.excludedLabelValue : this.includedLabelValue
    this.buttonTarget.title = excluded ? this.excludedTitleValue : this.includedTitleValue

    const activeClasses = ['bg-amber-100', 'text-amber-800', 'hover:bg-amber-200']
    const idleClasses = ['bg-gray-100', 'text-gray-600', 'hover:bg-gray-200']
    activeClasses.forEach(cls => this.buttonTarget.classList.toggle(cls, excluded))
    idleClasses.forEach(cls => this.buttonTarget.classList.toggle(cls, !excluded))

    this.element.classList.toggle('opacity-60', excluded)

    if (this.hasBadgeTarget) {
      this.badgeTarget.classList.toggle('hidden', !excluded)
    }
  }

  _csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}
